<template>
  <div class="c-modal-user-withdrawal-control">
    <b-modal
      @hidden="$emit('close')"
      size="lg"
      title="کنترل برداشت/واریز کاربر"
      :hide-footer="true"
      :id="id">
      <template v-if="user.loading">
        <BaseLoading/>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-12 d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex align-items-start justify-content-between flex-column">


              <b-form-checkbox
                class="mb-3"
                v-model="user.manualFiatDeposit"
                @change="updateManualFiatDeposit($event)"
                switch size="lg">
                <div style="font-size: 16px">
                  مجاز به واریز بانکی
                </div>
              </b-form-checkbox>

              <b-form-checkbox
                class="mb-3"
                :disabled="!adminsAccessOnly"
                v-model="user.exception"
                @change="updateUserExceptionStatus($event)"
                switch size="lg">
                <div style="font-size: 16px">
                  اعمال بالاترین برداشت روزانه
                </div>
              </b-form-checkbox>

              <b-form-checkbox
                v-model="user.untrastedCryptoWithdrawal"
                @change="updateUntrastedCryptoWithdrawal($event)"
                switch size="lg">
                <div style="font-size: 16px">
                اعمال پایین ترین برداشت روزانه
                </div>
              </b-form-checkbox>
            </div>

            <div style="width: 150px">
              <Multiselect
                @change="getUserWithdrawalControlData"
                rtl
                searchable
                v-model="user.max_withdraw_symbol"
                :options="coins"
              />
            </div>
          </div>
          <div class="col-12 d-flex align-items-center justify-content-start mb-2">
            <b>
              مقدار بلاک شده :
            </b>
            <span class="mr-2">
              {{ addCommas(user.blocked) }}  تومان
            </span>
          </div>
          <div class="col-12 d-flex align-items-center justify-content-start mb-2">
            <i></i>
            <b>
              بیشترین میزان برداشت رمزارز
              ,
              در واحد
              <b-badge variant="primary">
                {{ user.max_withdraw_symbol }}
              </b-badge>
              :
            </b>
            <span class="mr-2">
              {{ user.max_withdraw }}
            </span>
          </div>
          <div class="col-12 d-flex align-items-center justify-content-start mb-2">
            <b>
              کل موجودی کاربر تبدیل شده به تومان
              :
            </b>
            <span class="mr-2">
              {{ addCommas(user.total_assets_in_rtl) }}
            </span>
          </div>
          <div class="col-12 d-flex align-items-center justify-content-start mb-2">
            <b>
              امتیاز کاربر :
            </b>
            <span class="mr-2">
             {{ user.score }}
            </span>
          </div>
          <div class="col-12 d-flex align-items-start justify-content-start flex-column mb-2">
            <b>
              جدول امتیازات کاربر :
            </b>
            <div class="w-100">
              <table class="table mt-3" border="1">
                <thead>
                <tr>
                  <th
                    class="text-center"
                    v-for="(key,value) in user.queries"
                    :key="value"
                  >
                   Q {{ value+1 }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td
                    class="text-center"
                    v-for="(key,value) in user.queries"
                    :key="'td-'+value"
                  >
                    <i v-if="key" class="fa fa-check-circle fa-2x text-success"></i>
                    <i v-else class="fa fa-times fa-2x text-danger"></i>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect/dist/multiselect.vue2'
import BaseLoading from "@/components/BaseLoading";
import http from "@/httpservices/HttpService"
import {fetchFraudExceptionStatus, fetchUserFraudData, updateFraudException} from "@/httpservices/Fraud";
import Swal from "sweetalert2";
import store from "@/store"


export default {

  name: "ModalUserWithdrawalControl",

  components: {BaseLoading, Multiselect,},

  data() {
    return {
      coins: [],
      id: 'user-withdrawal-control-modal',
      user: {
        manualFiatDeposit: false,
        untrastedCryptoWithdrawal : false,
        loading: true,
        exception: false,
        max_withdraw: 0,
        max_withdraw_symbol: 'BTC',
        blocked: 0,
        total_assets_in_irt: 0,
        score: 0,
        queries: [],
      },
    }
  },

  computed: {
    adminsAccessOnly() {
      return Boolean(store.getters['isSuperAdmin'] || store.getters['isManagerAdmin']);
    }
  },

  mounted() {
    this.$nextTick(async () => {
      this.$bvModal.show(this.id);
      this.getAssets();
      await this.getUserWithdrawalControlData();
    });
  },

  methods: {


    async updateUserExceptionStatus(status) {
      const text = status
        ? "آیا از رفع تمام محدودیت های برداشت رمزارز کاربر مطمئن هستید؟"
        : "آیا از اعمال تمام محدودیت های برداشت رمزارز کاربر مطمئن هستید؟";
      const {isConfirmed} = await Swal.fire({
        title: "توجه",
        html: text,
        confirmButtonText: "بله",
        cancelButtonText: `خیر`,
        showCancelButton: true
      });
      if (!isConfirmed) {
        this.user.exception = !this.user.exception;
        return
      }
      try {
        await updateFraudException(this.$route.params.id, {
          "type": "CryptoWithdrawal",
          "status": this.user.exception
        });
        await Swal.fire({
          title: "با موفقیت انجام شد.",
          icon: "success",
          confirmButtonText: "باشه"
        });
        await this.getUserWithdrawalControlData();
      } catch (e) {
        console.log({e})
      }
    },

    async updateManualFiatDeposit(status) {
      const text = status
        ? "آیا از رفع  محدودیت برای واریز بانکی کاربر مطمئن هستید؟"
        : "آیا از اعمال  محدودیت برای واریز بانکی کاربر مطمئن هستید؟";
      const {isConfirmed} = await Swal.fire({
        title: "توجه",
        html: text,
        confirmButtonText: "بله",
        cancelButtonText: `خیر`,
        showCancelButton: true
      });
      if (!isConfirmed) {
        this.user.manualFiatDeposit = !this.user.manualFiatDeposit;
        return
      }

      try {
        await updateFraudException(this.$route.params.id, {
          "type": "ManualFiatDepositTrusted",
          "status": this.user.manualFiatDeposit
        });
        await Swal.fire({
          title: "با موفقیت انجام شد.",
          icon: "success",
          confirmButtonText: "باشه"
        });
        await this.getUserWithdrawalControlData();
      } catch (e) {
        console.log({e})
      }
    },

    async updateUntrastedCryptoWithdrawal(status) {
      const text = status
        ? "آیا از اعمال محدودیت های برداشت رمزارز کاربر مطمئن هستید؟"
        : "آیا از رفع محدودیت های برداشت رمزارز کاربر مطمئن هستید؟";
      const {isConfirmed} = await Swal.fire({
        title: "توجه",
        html: text,
        confirmButtonText: "بله",
        cancelButtonText: `خیر`,
        showCancelButton: true
      });
      if (!isConfirmed) {
        this.user.untrastedCryptoWithdrawal = !this.user.untrastedCryptoWithdrawal;
        return
      }

      try {
        await updateFraudException(this.$route.params.id, {
          "type": "untrastedCryptoWithdrawal",
          "status": this.user.untrastedCryptoWithdrawal
        });
        await Swal.fire({
          title: "با موفقیت انجام شد.",
          icon: "success",
          confirmButtonText: "باشه"
        });
        await this.getUserWithdrawalControlData();
      } catch (e) {
        console.log({e})
      }
    },

    async getUserWithdrawalControlData() {
      this.user.loading = true;
      try {
        const {manualFiatDepositTrusted,cryptoWithdrawal,untrastedCryptoWithdrawal } = (await fetchFraudExceptionStatus(this.$route.params.id)).data || {};
        const res2 = (await fetchUserFraudData(this.$route.params.id, this.user.max_withdraw_symbol)).data || {};
        this.user = {
          ...this.user,
          exception: Boolean(cryptoWithdrawal),
          untrastedCryptoWithdrawal : Boolean(untrastedCryptoWithdrawal ),
          manualFiatDeposit: Boolean(manualFiatDepositTrusted),
          max_withdraw: res2.max_withdraw,
          max_withdraw_symbol: res2.max_withdraw_symbol,
          blocked: res2.blocked,
          total_assets_in_irt: res2.total_assets_in_irt,
          score: res2.score,
          queries: res2.query_results,
        }
      } catch (e) {
        console.log(e)
      }
      this.user.loading = false;
    },

    getAssets() {
      const token = localStorage.getItem("token") || "";

      http.get("/Assets/")
        .then((response) => {
          this.coins = response.data.map(item => item.name).filter(item => item !== 'IRT');
        })
        .catch(() => {
          //console.log(err);
          //this.$router.push("/500");
        });
    },

  },


}


</script>

<style scoped>
@import "~@vueform/multiselect/themes/default.css";
</style>
